import { render, staticRenderFns } from "./HistoricAccount.vue?vue&type=template&id=09686a4f&scoped=true&"
import script from "./HistoricAccount.vue?vue&type=script&lang=ts&"
export * from "./HistoricAccount.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricAccount.vue?vue&type=style&index=0&id=09686a4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09686a4f",
  null
  
)

export default component.exports